var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 9","fill":"currentColor"}},[_c('path',{attrs:{"fill-rule":"evenodd","d":"m12.831 1.564 3.231 2.91L0 4.511v.86l16.102.019-3.251 2.929.687.622L18 4.95 13.517.941z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }